import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { useInView } from '../hooks/useInView';

const CTASection = () => {
  const [ref, isInView] = useInView({ threshold: 0.2 });

  return (
    <section ref={ref} className="py-20 bg-stone-100 relative overflow-hidden">
      {/* Decorative background with animated bubbles */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#8B2942] rounded-full -translate-x-1/2 -translate-y-1/2 animate-[float_8s_ease-in-out_infinite]" />
        <div className="absolute bottom-0 right-0 w-72 h-72 bg-[#6d2033] rounded-full translate-x-1/3 translate-y-1/3 animate-[float_10s_ease-in-out_infinite_1s]" />
        <div className="absolute top-1/3 right-1/4 w-56 h-56 bg-[#a83756] rounded-full animate-[float_12s_ease-in-out_infinite_2s]" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <div
          className={`transition-all duration-400 ${
            isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-[#8B2942] mb-6">
            Vous avez un projet immobilier ?
          </h2>
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
            Contactez-moi pour une estimation personnalisée et sans engagement de votre bien. 
            Je serai ravie de vous accompagner dans votre projet.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              asChild
              size="lg"
              className="bg-[#8B2942] hover:bg-[#6d2033] text-white"
            >
              <Link to="/contact" className="flex items-center gap-2">
                <Phone className="w-5 h-5" />
                Contactez-moi
              </Link>
            </Button>
            <Button
              asChild
              size="lg"
              variant="outline"
              className="border-[#8B2942] text-[#8B2942] hover:bg-[#8B2942] hover:text-white group"
            >
              <Link to="/a-vendre" className="flex items-center gap-2">
                Voir les biens
                <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
